// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.manager[data-v-1161f3d2] {

    display: flex;

    flex-direction: column;

    row-gap: 1.5rem
}
.manager__subtitle[data-v-1161f3d2] {

    font-size: 1rem
}
@media (min-width: 768px) {
.manager__subtitle[data-v-1161f3d2] {

        font-size: 1.125rem
}
}
.manager__body[data-v-1161f3d2] {

    display: flex;

    flex-direction: row;

    -moz-column-gap: 3rem;

         column-gap: 3rem;

    padding-top: 2.5rem;

    padding-bottom: 2.5rem
}
.manager__body__tabs[data-v-1161f3d2] {

    display: flex;

    flex-direction: column;

    row-gap: 1.5rem
}
@media (min-width: 768px) {
.manager__body__tabs[data-v-1161f3d2] {

        min-width: 10.5rem;

        border-right-width: 1px;

        --tw-border-opacity: 1;

        border-color: rgb(209 213 219 / var(--tw-border-opacity));

        padding-right: 2rem
}
}
.manager__body__tabs__content[data-v-1161f3d2] {

    position: relative
}
.manager__body__tabs a[data-v-1161f3d2] {

    display: flex;

    flex-direction: column;

    row-gap: 0.75rem;

    font-size: 1.125rem;

    font-weight: 700
}
@media (min-width: 768px) {
.manager__body__tabs a[data-v-1161f3d2] {

        font-size: 1rem;

        font-weight: 400;

        --tw-text-opacity: 1;

        color: rgb(107 114 128 / var(--tw-text-opacity))
}
.manager__body__tabs a.selected[data-v-1161f3d2] {

        font-weight: 700;

        --tw-text-opacity: 1;

        color: rgb(0 154 250 / var(--tw-text-opacity))
}
}
.manager__body__tabs a span[data-v-1161f3d2] {

    font-size: 1rem;

    font-weight: 400
}
@media (min-width: 768px) {
.manager__body__tabs a span[data-v-1161f3d2] {

        display: none
}
}
.manager__body__tabs__separator[data-v-1161f3d2] {

    margin-bottom: 1.5rem;

    --tw-border-opacity: 1;

    border-color: rgb(209 213 219 / var(--tw-border-opacity))
}
@media (min-width: 768px) {
.manager__body__tabs__separator[data-v-1161f3d2] {

        display: none
}
}
.manager__body__tabs__toggle[data-v-1161f3d2] {

    position: absolute;

    right: 0
}
@media (min-width: 768px) {
.manager__body__tabs__toggle[data-v-1161f3d2] {

        display: none
}
}
.manager__body__panels[data-v-1161f3d2] {

    display: none
}
@media (min-width: 768px) {
.manager__body__panels[data-v-1161f3d2] {

        display: block
}
}
.manager__body__panel__title[data-v-1161f3d2] {

    margin-bottom: 1.5rem;

    font-weight: 700
}
.manager__body__panel__toggle[data-v-1161f3d2] {

    float: right
}
.manager__footer[data-v-1161f3d2] {

    display: flex;

    width: 100%;

    flex-direction: column-reverse;

    align-items: center;

    justify-content: space-between;

    gap: 1.5rem
}
@media (min-width: 768px) {
.manager__footer[data-v-1161f3d2] {

        flex-direction: row
}
}
.manager__footer a[data-v-1161f3d2] {

    text-decoration-line: underline
}
.manager__footer a[data-v-1161f3d2]:hover {

    text-decoration-line: none
}
.manager__footer__buttons[data-v-1161f3d2] {

    display: flex;

    width: 100%;

    flex-direction: column-reverse;

    gap: 1rem
}
@media (min-width: 768px) {
.manager__footer__buttons[data-v-1161f3d2] {

        width: auto;

        flex-direction: row
}
.manager__footer__buttons--mobile[data-v-1161f3d2] {

        display: none
}
}
.manager__footer__buttons--desktop[data-v-1161f3d2] {

    display: none
}
@media (min-width: 768px) {
.manager__footer__buttons--desktop[data-v-1161f3d2] {

        display: block
}
}
.manager__footer__buttons buttons[data-v-1161f3d2] {

    width: 100%
}
@media (min-width: 768px) {
.manager__footer__buttons buttons[data-v-1161f3d2] {

        width: auto
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/cookies/Manager.vue"],"names":[],"mappings":";AAwFA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,qBAAA;;SAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,kBAAA;;QAAA,uBAAA;;QAAA,sBAAA;;QAAA,yDAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,eAAA;;QAAA,gBAAA;;QAAA,oBAAA;;QAAA;AAAA;AAGA;;QAAA,gBAAA;;QAAA,oBAAA;;QAAA;AAAA;AAHA;AAOA;;IAAA,eAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAKA;;IAAA,qBAAA;;IAAA,sBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAKA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAKA;;IAAA,qBAAA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAMA;;IAAA,aAAA;;IAAA,WAAA;;IAAA,8BAAA;;IAAA,mBAAA;;IAAA,8BAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAKA;;IAAA,aAAA;;IAAA,WAAA;;IAAA,8BAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,WAAA;;QAAA;AAAA;AAGA;;QAAA;AAAA;AAHA;AAOA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA","sourcesContent":["<template>\n  <Dialog v-model=\"dialogOpen\" title=\"Configuración de cookies\" class=\"manager\" scroll-shadow padding spaced large>\n    <div class=\"manager__subtitle\">\n      Utilizamos cookies propias y de terceros para fines analíticos y para mostrarte publicidad personalizada en base a un perfil elaborado\n      a partir de tus hábitos de navegación (por ejemplo, páginas visitadas).\n    </div>\n\n    <div class=\"manager__body\">\n      <div class=\"manager__body__tabs\">\n        <div v-for=\"(cookie, i) in legalCookies\" :key=\"cookie.key\" class=\"manager__body__tabs__content\">\n          <hr v-if=\"i > 0\" class=\"manager__body__tabs__separator\" />\n          <Toggle v-model=\"cookie.value\" :disable=\"cookie.required\" class=\"manager__body__tabs__toggle\" />\n          <a :href=\"`#${cookie.key}`\" :class=\"{ selected: tab === cookie.key }\" @click.prevent=\"tab = cookie.key\">\n            {{ cookie.name }}\n            <span>{{ cookie.description }}</span>\n          </a>\n        </div>\n      </div>\n\n      <div class=\"manager__body__panels\">\n        <div v-for=\"cookie in legalCookies\" :key=\"cookie.key\" v-show=\"tab === cookie.key\" class=\"manager__body__panel\">\n          <Toggle v-model=\"cookie.value\" :disable=\"cookie.required\" class=\"manager__body__panel__toggle\" />\n          <div class=\"manager__body__panel__title\">{{ cookie.name }}</div>\n          <p class=\"manager__body__panel__description\">{{ cookie.description }}</p>\n        </div>\n      </div>\n    </div>\n\n    <template #footer>\n      <div class=\"manager__footer\">\n        <a target=\"_blank\" href=\"/legal/politica-de-cookies\">Más información</a>\n\n        <div class=\"manager__footer__buttons\">\n          <Button class=\"manager__footer__buttons--desktop\" btn-style=\"ghost\" @click.native=\"save\">Guardar mis preferencias</Button>\n          <Button class=\"manager__footer__buttons--mobile\" btn-style=\"secondary\" @click.native=\"save\">Guardar preferencias</Button>\n          <Button @click.native=\"acceptAll\">Aceptar todas</Button>\n        </div>\n      </div>\n    </template>\n  </Dialog>\n</template>\n\n<script>\nimport Dialog from '@/lego/components/dialogs/Dialog.vue';\nimport { ref } from '@vue/composition-api';\nimport CookiesBus from '@/lego/utils/bus/cookies';\nimport Button from '@/lego/components/buttons/Button.vue';\nimport Toggle from '@/lego/components/toggles/Toggle.vue';\nimport Animation from '@/lego/components/tools/Animation.vue';\nimport { getLegalCookies, saveLegalCookies, acceptAllLegalCookies } from '@/lego/utils/navigator/cookies';\n\nexport default {\n  components: { Toggle, Dialog, Button, Animation },\n\n  setup() {\n    const legalCookies = ref(getLegalCookies());\n    const dialogOpen = ref(false);\n    const tab = ref(legalCookies.value[0]?.key);\n\n    CookiesBus.on('manager.open', () => {\n      dialogOpen.value = true;\n    });\n\n    CookiesBus.on('manager.close', () => {\n      dialogOpen.value = false;\n    });\n\n    function save() {\n      saveLegalCookies(legalCookies.value);\n\n      CookiesBus.emit('manager.close');\n      CookiesBus.emit('banner.close');\n    }\n\n    function acceptAll() {\n      acceptAllLegalCookies();\n\n      CookiesBus.emit('manager.close');\n      CookiesBus.emit('banner.close');\n    }\n\n    return { dialogOpen, tab, legalCookies, save, acceptAll };\n  },\n};\n</script>\n\n<style scoped lang=\"postcss\">\n.manager {\n  @apply flex flex-col gap-y-xxs;\n\n  &__subtitle {\n    @apply text-xs md:text-sm;\n  }\n\n  &__body {\n    @apply flex flex-row gap-x-md py-sm;\n\n    &__tabs {\n      @apply flex flex-col gap-y-xxs md:border-r-hairline md:border-neutral-semilight md:pr-xs md:min-w-[10.5rem];\n\n      &__content {\n        @apply relative;\n      }\n\n      a {\n        @apply md:text-neutral-semidark flex flex-col gap-y-micro font-bold md:font-regular text-sm md:text-xs;\n\n        &.selected {\n          @apply md:font-bold md:text-support-dark;\n        }\n\n        span {\n          @apply md:hidden font-regular text-xs;\n        }\n      }\n\n      &__separator {\n        @apply md:hidden mb-xxs border-neutral-semilight;\n      }\n\n      &__toggle {\n        @apply absolute right-0 md:hidden;\n      }\n    }\n\n    &__panels {\n      @apply hidden md:block;\n    }\n\n    &__panel {\n      &__title {\n        @apply font-bold mb-xxs;\n      }\n\n      &__toggle {\n        @apply float-right;\n      }\n    }\n  }\n\n  &__footer {\n    @apply w-full flex flex-col-reverse md:flex-row justify-between items-center gap-xxs;\n\n    a {\n      @apply underline;\n\n      &:hover {\n        @apply no-underline;\n      }\n    }\n\n    &__buttons {\n      @apply w-full md:w-auto flex flex-col-reverse md:flex-row gap-xxxs;\n\n      &--mobile {\n        @apply md:hidden;\n      }\n\n      &--desktop {\n        @apply hidden md:block;\n      }\n\n      buttons {\n        @apply w-full md:w-auto;\n      }\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
